import Sidbarv2 from "../../Workspace-v2/Sidbarv2";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Badge from "@mui/material/Badge";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
// import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import { motion } from "framer-motion";
import { Spinner } from "react-bootstrap";


import "../../../../src/WorkSpace/SignUp2.css";
import { Navbar } from "../../../Components/Navbar";
import { getAPI } from "../../../services/api/StandAlone/projectAPIs";
// import PresetInfo from "../../../PrivatePages/consolidatedFinancialStatement/PresetInfo";


import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { useHistory, useLocation } from "react-router";
import { GetAllProject, updateProject } from "../ApiServices/apiHandler";
import React, { useEffect, useState } from "react";

import moment from "moment";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import * as actionTypes from "../../../redux/actionTypes";
import swal from "sweetalert";
import "../../../../src/WorkSpace/font.css";
import { fetchWSData } from "../../../redux/actions/workspace/actionWorkspace";
import EditProject from "../Modal/editProject";
import TranslateFSModal from "../Modal/TranslateFSModal";


// import SideBarv2 from '../../WorkSpace/Workspace-v2/Sidbarv2';
import SideBarv2 from '../../../WorkSpace/Workspace-v2/Sidbarv2';
import commoncss from "../../../myfin_v2/css/common.module.css";
import Sidebar from "../../../myfin_v2/elements/Sidebar";
import { Button } from "../../../myfin_v2/elements/Button";
import StatusIndicator from "../../../myfin_v2/elements/StatusIndicator";
import standalonecss from "../../../myfin_v2/css/standalone.module.css";
import bookclosuretablecss from "../../../myfin_v2/css/bookclosuretable.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import tablecss from "../../../myfin_v2/css/table.module.css";


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#296F73" : "#308fe8",
  },
}));

const FinancialStatement = (props) => {
  const user = JSON.parse(localStorage.getItem("user"));
  // for popover
  const [anchorEl, setAnchorEl] = useState(null);
  const tableData = useSelector((state) => state.reducer.tableData);
  const [data, setData] = useState([]);
  const [barData, setBarDAta] = useState("");
  const [projectId, setProjectId] = useState("");
  const workspace_data = useSelector((state) => state.WSReducer);
  const [allProjectData, setallProjectData] = useState("");
  const [editModal, handleEditModal] = useState(false);
  const [editProject, setEditProject] = useState({
    company: "",
    name_finance: "",
    nature_finance: "",
    gaap: "",
    account: "",
  });
  const [search, setSearch] = useState("");
  const [showTranslateFSModal, setShowTranslateFSModal] = useState(false);
  const [loader, setLoader] = useState(true);

  const handleClick = (event, id, data) => {
    setAnchorEl(event.currentTarget);
    setProjectId(id);
    setallProjectData(data);
  };

  const handleClose = () => {
    setAnchorEl(null);
    handleEditModal(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  // end popover
  const location = useLocation();
  const dispatch = useDispatch();
  let history = useHistory();
  let a = location.pathname;
  let w_id = a.split("/");
  const [allProject, setAllProject] = useState([]);
  useEffect(() => {
    if (workspace_data.isSuccess === false) {
      dispatch(fetchWSData(w_id[2]));
    }
    AllProject();
    setData(tableData);
    selectedrows();
  }, []);

  const AllProject = async () => {
    const res = await GetAllProject(w_id[2]);
    if (res.status === 200) {
      setAllProject(res.data.project);
      setLoader(false);
    }
  };
  let total = 0;
  let finaldata = 0;
  const lenghtdata = data.length;
  const selectedrows = () => {
    total = total + 1;
    finaldata = (total / lenghtdata) * 100;
    setBarDAta(Math.round(finaldata));
  };
  function handleDelete(data) {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal(
        "Warning",
        "You Don't have Access to Delete Financial Statement",
        "warning"
      );
    } else {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to view the project",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          getAPI(`api/v1/project/delete-project/${data}`)
            .then((res) => {
              swal("", "Project has been deleted!", {
                icon: "success",
              });
              AllProject();
            })
            .catch((err) => {
              console.log("error delete project ---", err.response);
              swal("", "Project not deleted!", "error");
            });
        } else {
          swal("", "Project not deleted!", "error");
        }
      });
    }
  }
  function handleEnter(e, id) {
    const auth = localStorage.getItem("auth_token");
    let headers = {
      "x-auth-token": auth,
    };
    axios
      .get(`api/v1/tb-onboarding/get-tb/${id}`, { headers })
      .then((response) => {
        dispatch({ type: actionTypes.SET_TB_ID, payload: response.data.tb_id });
        window.localStorage.setItem("tb_id", response.data.tb_id);
        localStorage.setItem("project_id", response.data.project_id);
        axios
          .get(`api/v1/grouping/fs/${id}`, { headers })
          .then((res) => {
            if (res.data.fs_grp === []) {
              return;
            }
            const gp_data = {};
            gp_data.grp = res.data.fs_grp;
            dispatch({
              type: actionTypes.SET_EDITSUBGROUPING,
              payload: gp_data,
            });
          })
          .catch((error) => {
            console.log(error.response, "error");
          });
        history.push(`/templateV2/${id}`);
      })
      .catch((error) => {
        console.log(error.response, "error");
        // swal("", "Cannot found any TB inside this project", "error");
        history.push("/createProject/uploadTb");
      });
  }
  const handleData = () => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal(
        "Warning",
        "You Don't have Access to Create Financial Statement",
        "warning"
      );
    } else {
      history.push(`/createProject/QuestionnaireNew/${w_id[2]}`);
    }
  };

  const handleEdit = (data) => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal(
        "Warning",
        "You Don't have Access to Edit Financial Statement",
        "warning"
      );
    } else {
      handleEditModal(true);
    }
  };

  const goToPage = () => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal("warning", "You don't have access to Go", "warning");
    } else {
      history.push('/preset-information');
    }
  };

  const handleChnageEdit = (data, field) => {
    setEditProject({ ...editProject, [field]: data });
  };

  const submitEdit = async (id) => {
    let alldata = {
      company: editProject.company,
      project_name: editProject.name_finance,
      company_type: editProject.nature_finance,
      gaap_selection: editProject.gaap,
      preset_name: editProject.account,
    };
    const res = await updateProject(id, alldata);
    if (res.status === 200) {
      handleClose();
      swal("", "Updated Successfully", "success");
      AllProject();
    }
  };


  //search option
  const handleChange = (event) => {
    const searchData = event.target.value;
    setSearch(searchData);
    if (searchData === "") {
      AllProject();
    } else {
      const filerData = allProject.filter((project) =>
        project?.project_name.includes(searchData)
      );
      setAllProject(filerData);
    }
  };

  const tableHeaders = {
    financialStatments: "FINANCIAL STATEMENTS",
    periodEnd: "PERIOD END",
    groupingStatus: "GROUPING STATUS",
    logicalErrors: "LOGICAL ERRORS"
  };

  const headerClasses = {
    taskTemplateName: "stclTableTemplateNameTh",
  };
  return (
    <>

      <div className={commoncss.pageLayout}>
        {/* <Navbar /> */}
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <SideBarv2 w_id={w_id} />
          </motion.div>

          <div className={standalonecss.content}>
            <motion.div

              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className={standalonecss.headerPadding}>
              <div
                // initial={{ y: -100, opacity: 0 }}
                // animate={{ y: 0, opacity: 1 }}
                // exit={{ y: 0, opacity: 0 }}
                // transition={{ duration: 0.5, ease: "easeInOut" }}
                className={standalonecss.headerContent}>
                <div style={{ width: "20rem", "z-index": "100" }}>
                  <label className={commoncss.fs24}>Financial Statements</label>
                </div>
                <div className='d-flex'>
                  {workspace_data.response[0]?.access_status === "view" ? (
                    <Button
                      class_={commoncss.fs14}
                      btnColor={buttoncss.primary}
                      icon={<PlusIcon />}
                      label="Create Financial Statements"
                      isEnabled={false}
                    />
                  ) : (
                    <>
                      <Button
                        class_={commoncss.fs14}
                        btnColor={buttoncss.greyBg}
                        label="Translate FS"
                        onClick={() => { setShowTranslateFSModal(true) }}
                      />&ensp;
                      <Button
                        class_={commoncss.fs14}
                        btnColor={buttoncss.primary}
                        icon={<PlusIcon />}
                        label="Create Financial Statements"
                        onClick={handleData}
                      />
                    </>
                  )}

                </div>
              </div>
            </motion.div>

            <motion.div

              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className={`${standalonecss.fsTableContainer} mt-3`}
            >

              <div className={standalonecss.standaloneTableContainer}>
                <table className={standalonecss.standaloneTable}>
                  <thead>
                    <tr>
                      {Object.entries(tableHeaders).map(([key, label]) => {
                        return (
                          <th
                            key={key}
                            className={`${label === "FINANCIAL STATEMENTS" ? "w-50" : ""}`}
                            style={label === "GROUPING STATUS" ? { textAlign: "center" } : {}}
                          >
                            {label}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  {loader ? (
                    <div className={commoncss.fsTableLoaderDiv} >
                      <Spinner animation="grow" size="sm" />
                      <Spinner animation="grow" style={{ margin: "1rem" }} />
                      <Spinner animation="grow" size="sm" />
                    </div>
                  ) : (
                    <tbody>
                      {allProject.length > 0 &&
                        allProject.map((det, index) => {
                          return (
                            <React.Fragment key={index}>
                              <tr
                                key={index}
                              // onClick={() => ViewobjMore(obj._id)}
                              >
                                <td
                                  onClick={(e) => {
                                    handleEnter(e, det._id);
                                  }}
                                >
                                  {det.project_name}</td>
                                <td>{det?.current_year &&
                                  moment(det?.current_year).format("DD-MM-YYYY")}</td>
                                <td style={{ "place-items": "center" }}>
                                  {" "}
                                  <StatusIndicator
                                    status={det?.grouping_status}
                                  />
                                </td>
                                <td>
                                  {""}
                                </td>
                              </tr>
                            </React.Fragment>
                          )
                        })}
                    </tbody>
                  )}
                </table>
              </div>
            </motion.div>
          </div>

        </div>
      </div>

      <EditProject
        open={editModal}
        handleClose={handleClose}
        // editData={companyData}
        handleChnageEdit={handleChnageEdit}
        submitEdit={submitEdit}
        allProjectData={allProjectData}
      />
      {showTranslateFSModal && (
        <TranslateFSModal
          setShowTranslateFSModal={setShowTranslateFSModal}
        />

      )}
    </>
  );
};

export default FinancialStatement;
